import checkToken from '../api/checkToken'

const onCheckComplete = (dispatch, userName, token) => (err) => {
  dispatch({type: 'restore_token', userName, token})
}

export default (userName, token) => (dispatch, getState) => {
  if(userName && token) {
    checkToken(userName, token, onCheckComplete(dispatch, userName, token))
  }
}




/** WEBPACK FOOTER **
 ** ./app/actions/restoreSession.js
 **/